module.exports = __webpack_public_path__ + "static/media/arrow-down.15e19f79.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-down.svg
// module id = 1382
// module chunks = 1